import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import classnames from 'classnames';

import TableGridRow from '../TableGridRow/TableGridRow';

import { IInquiriesGridCardProps } from './InquiriesGridCard.interface';

import './style.scss';

const InquiriesGridCard: FC<IInquiriesGridCardProps> = ({ className, data }) => {
  const { t } = useTranslation();

  return (
    <Box className={classnames('admin-grid-card', className)}>
      <TableContainer component={Paper} className="admin-grid-card__table" elevation={0}>
        <Table aria-label="collapsible table" size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t('adminInquiries.date')}</TableCell>
              <TableCell>{t('adminInquiries.inquiryId')}</TableCell>
              <TableCell>{t('adminInquiries.items')}</TableCell>
              <TableCell>{t('adminInquiries.org')}</TableCell>
              <TableCell>{t('adminInquiries.type')}</TableCell>
              <TableCell>{t('adminInquiries.time')}</TableCell>
              <TableCell />
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(row => (
              <TableGridRow key={row.id} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default InquiriesGridCard;
